import { render, staticRenderFns } from "./EditorCanvas.vue?vue&type=template&id=b28442e0&scoped=true&lang=pug&"
import script from "./EditorCanvas.vue?vue&type=script&lang=js&"
export * from "./EditorCanvas.vue?vue&type=script&lang=js&"
import style0 from "./EditorCanvas.vue?vue&type=style&index=0&id=b28442e0&prod&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b28442e0",
  null
  
)

export default component.exports